<template>
  <mdb-modal :show="modal" @close="closeModal()" size="xl" scrollable >
    <mdb-modal-header>
      <mdb-modal-title>{{$t('Global.PolicyModalHeadline')}}</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body>
      <mdb-tab-content>
        <h3>{{ $t('Global.Policy.term') }} <router-link :to="{ name: 'datenschutz' }">{{ $t('Global.Policy.tos') }}</router-link> {{ $t('Global.Policy.end') }}</h3>
        <p>{{$t('Global.PolicyText')}}</p>

      </mdb-tab-content>
    </mdb-modal-body>
    <mdb-modal-footer>
      <mdb-btn color="primary" @click.native="confirm()">{{$t('Global.Confirm')}}</mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import {
  mdbBtn, mdbCol, mdbContainer, mdbIcon,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbModalTitle, mdbRow,
  mdbTab, mdbTabContent,
  mdbTabItem, mdbTabPane, mdbTabs
} from "mdbvue";
import UserService from "@/services/UserService";

export default {
name: "PolicyModal",
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbTab,
    mdbTabItem,
    mdbTabContent,
    mdbTabPane,
    mdbContainer,
    mdbCol,
    mdbRow,
    mdbIcon,
    mdbTabs,
  },
  data() {
    return {
      modal: false,
      link: '/datenschutz',
      path: this.$i18n.t('Global.Policy.term'),
      term: this.$i18n.t('Global.Policy.tos')
    };
  },
  methods:{
    closeModal() {
      //preventDefault();
      //this.modal = false;
    },
    confirm(){
      UserService.confirmPolicy(this.$store.getters.userObject.persistence_object_identifier).then(response => {
        this.$store.dispatch("acceptPolicy", this.user);
        this.modal = false;
        this.$notify.success({
          message: "Ihr Account wurde aktualisiert!",
          position: 'top right',
          timeOut: 4000
        });
      })

    },
    openModal(){
      this.modal = true;
    }
  },
  computed:{

  },
  mounted(){
    if(this.$store.getters.userObject.confirmedPolicy == 0){
      this.modal = true;
    }
  }
}
</script>

<style scoped>

</style>